



























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { date, uid } from 'quasar';
import formatDate = date.formatDate;

@Component
export default class FlightList extends Vue {
  @Prop() flights!: any[];
  @Prop() value!: any;
  @Prop() direction!: 'outbound' | 'return';
  showMore = false;
  localStorage: any[] = [];
  formatDate = formatDate;
  baseUrl = process.env.VUE_APP_PROXY_URL + '/pxm/media';

  get list() {
    const flights = this.localStorage.map((flight) => {
      flight.key = uid();
      return flight;
    });

    return this.showMore ? flights : flights.slice(0, 5);
  }

  timeDiff(startDate: Date, endDate: Date) {
    return this.timeConvert(date.getDateDiff(startDate, endDate, 'minutes'));
  }

  @Watch('flights', { immediate: true })
  onFlights() {
    this.localStorage = this.flights.map((flight) => {
      return {
        ...flight,
        showRoutes: false,
      };
    });
  }

  timeConvert(m: number): string {
    const hours = m / 60;
    const rHours = Math.floor(hours);
    const minutes = (hours - rHours) * 60;
    const rMinutes = Math.round(minutes);

    let hourStr = '';
    if (rHours === 1) {
      hourStr = `${rHours} ${this.$t('GENERAL.HOUR')}`;
    } else if (rHours > 1) {
      hourStr = `${rHours} ${this.$t('GENERAL.HOURS')}`;
    }

    let minuteStr = '';
    if (rMinutes === 1) {
      minuteStr = ` ${rMinutes} ${this.$t('GENERAL.MINUTE')}`;
    } else if (rMinutes > 1) {
      minuteStr = ` ${rMinutes} ${this.$t('GENERAL.MINUTES')}`;
    }

    return hourStr + minuteStr;
  }

  clear() {
    this.$emit('input', null);
  }
}
